export default __webpack_public_path__ + "f65b676f68aeb112aabefa1aba3ccabd.jpg";